// for querying spaces by title or returning all spaces by limit (25) if !input
export const searchSpaces = async (input) => {
  const url = !input
    ? `/rest/api/search?cql=type=space and space.title ~ "*"`
    : `/rest/api/search?cql=type=space and space.title ~ "${input}*"`;

  try {
    const response = await window.AP.request(url);
    const body = JSON.parse(response.body);
    const spaces = body.results;
    return spaces.map((s) => s.space);
  } catch (err) {
    console.log(err);
    return [];
  }
};

export const getSpacesByKey = async (spaceKeys) => {
  try {
    const spaces = await Promise.all(
      spaceKeys.map(async (key) => {
        const response = await window.AP.request(`/rest/api/space?spaceKey=${key}`);
        const body = JSON.parse(response.body);
        const space = body.results[0];
        return space;
      })
    );
    return spaces;
  } catch (err) {
    console.log(err);
    return [];
  }
};

export const extractSpaceDataForSelect = (spaces) => {
  const keyNamePairs = spaces.map((space) => ({
    label: space.name,
    value: space.key,
  }));
  return keyNamePairs;
};
